if (!customElements.get('collection-grid')) {
    class CollectionGrid extends HTMLElement {
        constructor() {
            super();

            this.elViews = this.querySelectorAll('[data-collection-view]');
            this.elProducts = this.querySelector('[data-collection-products]');
            this.elProductCards = this.elProducts.querySelectorAll('[data-product-card]');
            // this.elObserve = this.querySelector('[data-observer]');

            // this.pageCurrent = 1;
            // this.pageTotal = Math.ceil(this.elProductCards.length / 12);
            // console.log(this.pageTotal)

            this.elViews.forEach(el => el.addEventListener('change', this.setView.bind(this)));
            // this.observer = this.elObserver ? new IntersectionObserver(this.paginateCollection.bind(this)).observe(this.elObserver) : null;
        }

        setView(ev) {
            ev.preventDefault();
            const elView = ev.currentTarget;
            const view = elView.value;
            this.classList.add('loading');
            setTimeout(() => {
                this.elProducts.style.setProperty('--columns', view);
                this.elProducts.setAttribute('data-columns', view);
            }, 300);
            setTimeout(() => {
                this.classList.remove('loading');
            }, 600);
        }

        paginateCollection([entry], observer) {
            if (entry.isIntersecting && this.pageCurrent < this.pageTotal) {

            }
        }
    }
    customElements.define('collection-grid', CollectionGrid);
}